<app-navbar></app-navbar>
<!-- <app-users></app-users> -->
<div class="container">
  <!-- <app-posts></app-posts> -->
  <router-outlet></router-outlet>
</div>
